import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectNumberingDatalist } from '../../Selectors/TrackSelector/TrackSelector';
import { Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';

import { fetchNumberingList } from '../../../Store/PHPSlice/Numbering/numberingApi';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import { fetchManualStkItem, fetchManualStkTransfer } from '../../../Store/PHPSlice/Stock/StockApis';
import { selectManStkTransfer, selectManualStkItem } from '../../Selectors/StitchSelector/StitchingSelectors';


const ManStkTransferView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({});
    const dispatch = useDispatch();
    const manualstk = useSelector(selectManStkTransfer);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    useEffect(() => {
        dispatch(fetchManualStkTransfer(Id))
    }, [Id, dispatch]);

    useEffect(() => {
        if (manualstk?.data) {
            setFormData(manualstk?.data);
        }

        const total = manualstk?.info?.reduce((acc, sum) => acc + parseFloat(sum.qty), 0);
        setFormData(prev => ({
            ...prev,
            totqty: total
        }));
    }, [manualstk]);

    // console.log(manualstk);
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>
                        {/* {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />} */}
                        <h3 className='centered-heading'>Manual Stock Transfer Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.date}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Memo</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.trmemo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.itemNm}</td>
                                    <td style={{ width: '200px' }}>Rack</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.rack}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }}>{formData.mclothNm}</td>
                                    <td style={{ width: '200px' }}>M1 Cloth</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.m1clothNm}</td>
                                </tr>


                                <tr>
                                    <td style={{ width: '200px' }}>M2 Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.m2clothNm}</td>
                                    <td style={{ width: '200px' }}>M3 Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.m3clothNm}</td>
                                </tr>



                                <tr>
                                    <td style={{ width: '200px' }}>Total Qty.</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.totqty}</td>
                                    <td style={{ width: '200px' }}>Bail No.</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.bailno}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>From Location</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.prev_locNm}</td>
                                    <td style={{ width: '200px' }}>To Location</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.new_locNm}</td>
                                </tr>
                            </tbody>


                        </table>
                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Barcode</TableCell> */}
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Color</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Shade No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Bal Qty.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(manualstk.info) && manualstk.info?.length > 0 ? (
                                        manualstk.info?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.barcode}</TableCell> */}
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.color}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.shadeNo}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.rate}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.qty}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.balqty}</TableCell>
                                            </TableRow>
                                        ))

                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align='center'>No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default ManStkTransferView;
